<template>
    <div v-click-outside="close" class="lang-wrapper">
        <div class="lang-btn" @click="open = !open">
            {{ currentLabel }}
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path d="M2 3.5l3 3 3-3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <transition name="menu-drop">
            <div v-if="open" class="lang-dropdown">
                <div
                    v-for="opt in languages"
                    :key="opt.value"
                    class="lang-option"
                    :class="{ active: opt.value === $i18n.locale }"
                    @click="select(opt.value)"
                >{{ opt.label }}</div>
            </div>
        </transition>
    </div>
</template>

<script>
import { LANGUAGES } from '@/core/i18n';

export default {
    name: 'NavLanguageSelect',
    data() {
        return {
            open: false,
            languages: LANGUAGES
        };
    },
    computed: {
        currentLabel() {
            return this.languages.find(o => o.value === this.$i18n.locale)?.label || 'English';
        }
    },
    methods: {
        close() {
            this.open = false;
        },
        select(value) {
            this.$i18n.locale = value;
            localStorage.setItem('lan', value);
            this.open = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.lang-wrapper {
    position: relative;
}

.lang-btn {
    background: var(--surface-control);
    color: var(--text);
    border-radius: 8px;
    height: 32px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
    gap: 2px;

    svg {
        margin-left: 3px;
    }
}

.lang-dropdown {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    min-width: 80px;
    background: linear-gradient(165deg, var(--surface-3) 0%, var(--surface-0) 100%);
    border: 1px solid var(--border);
    border-radius: 10px;
    overflow: hidden;
    z-index: 400;
    box-shadow: 0 8px 24px color-mix(in srgb, var(--black) 50%, transparent);
}

.lang-option {
    padding: 10px 16px;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-sub);
    cursor: pointer;
    transition: background 0.15s;

    &:hover {
        background: var(--surface-hover);
    }

    &.active {
        color: var(--highlight);
        font-weight: 600;
    }
}

.menu-drop-enter-active,
.menu-drop-leave-active {
    transition: opacity 0.15s ease, transform 0.15s ease;
}

.menu-drop-enter,
.menu-drop-leave-to {
    opacity: 0;
    transform: translateY(-6px);
}
</style>
